import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {withStyles} from '@material-ui/core/styles';
import {CustomButton} from '../../material-dashboard-pro-react/components/index';
import {Check} from '../../icons/index';
import style from '../../styles/components/button';

import './style.css';

function ButtonAdopt(props) {
  const {
    classes,
    customClasses,
    disabled,
    onClick,
  } = props;

  return (
    <CustomButton
      color="green"
      customClasses={customClasses}
      disabled={disabled}
      onClick={onClick}
      size="xs"
    >
      <Check className={classes.button__icon} />
      <span className="button-adopt__text">{I18n.t('buttons.adopt').toUpperCase()}</span>
    </CustomButton>
  );
}

ButtonAdopt.propTypes = {
  classes: PropTypes.object.isRequired,
  customClasses: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

ButtonAdopt.defaultProps = {
  customClasses: '',
  disabled: false,
};

export default withStyles(style)(ButtonAdopt);
